// extracted by mini-css-extract-plugin
module.exports = {"root":"AccordionInner_root__VrwiA","title":"AccordionInner_title__3phMa","accordion":"AccordionInner_accordion__XPeA9"};